export enum EditableTableActions {
	TABLE_ROW_ACTION = 'SelectRowAction',
}

export class DefaultRow {
	disabled?: boolean;
	getValue?: any;
}
